import moment from 'moment';

export const parseDate = dateString => {
  const regexFull = RegExp(
    '([0-2]?[0-9])\\.([0-1]?[0-9])\\.([0-2][0-9][0-9][0-9])',
  );
  const regexShortYear = RegExp('([0-2]?[0-9])\\.([0-1]?[0-9])\\.([0-9][0-9])');
  const regexNoYear = RegExp('([0-2]?[0-9])\\.([0-1]?[0-9])\\.?');
  const regexNoMonth = RegExp('([0-2]?[0-9])\\.?');

  let date = moment();

  if (dateString.match(regexFull)) {
    date = moment(dateString, 'DD.MM.YYYY');
  } else if (dateString.match(regexShortYear)) {
    date = moment(dateString, 'DD.MM.YY');
  } else if (dateString.match(regexNoYear)) {
    date = moment(dateString, 'DD.MM.');
  } else if (dateString.match(regexNoMonth)) {
    date = moment(dateString, 'DD.');
  }

  if (!date.isValid()) {
    date = moment();
  }

  return date;
};

export default parseDate;



// WEBPACK FOOTER //
// ./src/helpers/parseDate.js